export default __webpack_public_path__ + "static/img3-93c9ba50d00c3947f0bced1a63723368.jpg";